export const TOGGLE_DARK_MODE = "TOGGLE_DARK_MODE";

export const toggleMode = (mode) => dispatch => {
    dispatch({
        type: TOGGLE_DARK_MODE,
        mode
    });
}